import { QrCodeView } from './QrCodeView';
import { Button } from './ui/Button';
import { useCopy } from '@/hooks/useCopy';
import { shortId } from '@/lib/format';

export interface IdentityCardProps {
  did: string;
  peerId: string;
  name?: string;
  /** 分享链接（形如 https://host/?peer=xxx&did=yyy） */
  shareLink?: string;
  onCopyLink?: (link: string) => void;
  className?: string;
}

/** DID + PeerID + 二维码 + 分享链接（PRD W-ID-06）。 */
export function IdentityCard({ did, peerId, name, shareLink, onCopyLink, className }: IdentityCardProps): JSX.Element {
  const { copied, copy } = useCopy();
  const link =
    shareLink ??
    (typeof window !== 'undefined'
      ? `${window.location.origin}/add?peer=${encodeURIComponent(peerId)}&did=${encodeURIComponent(did)}`
      : '');

  const handleCopy = (): void => {
    onCopyLink?.(link);
    void copy(link, '分享链接已复制');
  };

  return (
    <div className={`card p-5 ${className ?? ''}`}>
      {name ? <p className="mb-3 text-sm font-medium text-text">{name}</p> : null}

      <QrCodeView value={link} size={200} copyable={false} label="扫码添加我为好友" />

      <dl className="mt-4 space-y-2 text-xs">
        <div>
          <dt className="text-dim">DID</dt>
          <dd className="mono break-all text-text">{did}</dd>
        </div>
        <div>
          <dt className="text-dim">PeerID</dt>
          <dd className="mono break-all text-text">{peerId || shortId(peerId, 12, 6)}</dd>
        </div>
      </dl>

      <Button variant="ghost" size="sm" block className="mt-4" onClick={handleCopy}>
        {copied ? '已复制 ✓' : '复制分享链接'}
      </Button>
    </div>
  );
}

export default IdentityCard;
